import axiosInstance from "../axios_instance";

export async function createRole(body) {
  const obj = { ...body, requestedAccess: 'View' }
  try {
    return await axiosInstance.post(`roles/`, obj);
  } catch (error) {
    return error;
  }
}

export async function updateRole(body, id) {
  try {
    return await axiosInstance.put(`roles/${id}`, body);
  } catch (error) {
    return error;
  }
}

export async function deleteRole(id) {
  try {
    const obj = { requestedAccess: 'Edit' }
    return await axiosInstance.delete(`roles/${id}`, obj);
  } catch (error) {
    return error;
  }
}

export async function getAllRoles() {
  try {
    return await axiosInstance.get(`roles/`);
  } catch (error) {
    return error;
  }
}

export async function getRolePermissionsById() {
  try {
    return await axiosInstance.get(`roles/getPermissions/`);
  } catch (error) {
    return error;
  }
}
